import React from 'react';
import { NavLink } from 'fluxible-router';
import OrderItem from '../../models/OrderItem';
import shallowCompare from '../../lib/shallowCompare';
import ShoppingCartActions from '../../actions/ShoppingCartActions';
import styles from './index.sass';

export const PhotoPositions = {
  Right: 'right',
  Left: 'left'
};

class OrderItemTile extends React.Component {
  static propTypes = {
    orderItem: React.PropTypes.instanceOf(OrderItem),
    storeId: React.PropTypes.string,
    className: React.PropTypes.string,
    photoPosition: React.PropTypes.string,
    showBuyAgainButton: React.PropTypes.bool,
    showTotal: React.PropTypes.bool
  };

  static defaultProps = {
    className: '',
    showBuyAgainButton: false,
    showTotal: false,
    photoPosition: PhotoPositions.Right
  };

  static contextTypes = {
    executeAction: React.PropTypes.func,
    trackEvent: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  handleOnClickBuyAgainButton(e) {
    this.context.executeAction(ShoppingCartActions.addItem, {
      store_id: this.props.storeId,
      inventory_record_id: this.props.orderItem.inventory_record.id,
      quantity: 1,
      inventoryRecord: this.props.orderItem.inventory_record,
      navigateToBagOnSuccess: true
    });
    this.context.trackEvent('buy_again', {
      order_store_id: this.props.storeId,
      inventory_record_id: this.props.orderItem.inventory_record.id
    });
  }

  render() {
    let { orderItem, showBuyAgainButton, showTotal } = this.props;
    let inventoryRecord = orderItem.inventory_record;
    let priceText = inventoryRecord.sale_price_text || inventoryRecord.price_text;
    let buyAgainButton, total, name, linkProps;
    let photo = <img className={styles.photo} src={inventoryRecord.photo_hash.getClosestToTarget(300)} />;
    let nameProps = { className: styles.name };

    if(showBuyAgainButton) {
      let buyAgainButtonText = 'Buy again';
      let buyAgainButtonProps = {
        className: styles.buyAgainButton,
        onClick: this.handleOnClickBuyAgainButton.bind(this)
      };
      if(inventoryRecord.availability === 'sold_out') {
        buyAgainButtonText = 'Sold out';
        buyAgainButtonProps.disabled = true;
      } else if(inventoryRecord.availability === 'unavailable') {
        buyAgainButtonText = 'Unavailable';
        buyAgainButtonProps.disabled = true;
      }
      buyAgainButton = <button {...buyAgainButtonProps}>{buyAgainButtonText}</button>;
    }
    if(showTotal) {
      total = <span className={styles.total}>{orderItem.total_text}</span>;
    }

    if(inventoryRecord.slug) {
      linkProps = {
        routeName: 'inventoryRecord',
        navParams: {
          id: inventoryRecord.id,
          slug: inventoryRecord.slug
        }
      };
      name = <NavLink {...nameProps} {...linkProps}>{inventoryRecord.name}</NavLink>;
      photo = <NavLink className={styles.photoLink} {...linkProps}>{photo}</NavLink>;
    } else {
      name = <span {...nameProps}>{inventoryRecord.brand} {inventoryRecord.name}</span>;
    }

    return (
      <div className={`${styles.orderItem} ${this.props.className} ${styles[this.props.photoPosition]}`} key={orderItem.id}>
        {photo}
        <span className={styles.quantity}>{orderItem.quantity}</span>
        <div className={styles.details}>
          {name}
          <div className={styles.variantPriceLine}>
            <span className={styles.price}>{priceText}</span>
          </div>
        </div>
        {buyAgainButton}
        {total}
      </div>
    );
  }
}

export default OrderItemTile;



// WEBPACK FOOTER //
// banquet/components/OrderItemTile/index.js